module.exports = __webpack_public_path__ + "img/card_mataro_background.f9125eac.png";